import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// services
import { onboardingService } from '../services/onboardingService'

// types
import { Form, ModetailsData } from '../types/onboardingTypes'

type Store = {
  formList: Form[]
  loading: boolean
  psdloading: boolean
  error: string | null
  progress: number
  tempdata: any
  modetailsData: ModetailsData
  clearData: () => void
  fetchData: (id: number) => void
  postData: (
    id: number,
    formId: number,
    isdirectdeposit: boolean,
    data: any
  ) => void
  markDocAsRead: (id: number, formId: number) => void
  updateProgress: (progress: number) => void
  downloadFile: (essFormKey: number) => void
  postW4Data: (data) => void
  getw4Details: (formkey, obkey) => void
  submittedForm: (formkey, obkey) => any
  posti9details: (data) => any
  postdirectdepositonline: (data) => any
  postalonline: (data) => any
  postiowaonline: (data) => any
  postwotconline: (data) => any
  postlaonline: (data) => any
  postgaonline: (data) => any
  postcaonline: (data) => any
  postaronline: (data) => any
  postkyonline: (data) => any
  postctonline: (data) => any
  postazonline: (data) => any
  postcoonline: (data) => any
  postdconline: (data) => any
  postdeonline: (data) => any
  postidonline: (data) => any
  posthionline: (data) => any
  postpaonline: (data) => any
  postMaOnline: (data) => any
  postMdOnline: (data) => any
  postKarnsOnline: (data) => any
  postWCRightsOnline: (data) => any
  postEEOOnline: (data) => any
  postKSonline: (data) => any
  postokonline: (data) => any
  postvaonline: (data) => any
  post8850online: (data) => any
  postoronline: (data) => any
  postmoonline: (data) => any
  getmodetails: (id: number) => void
  postgrenadehandbook: (data) => any
  postgrenadepolicy: (data) => any
  postmsonline: (data) => any
  postilonline: (data) => any
  postwionline: (data) => any
  postinonline: (data) => any
  postmtonline: (data) => any
  postrionline: (data) => any
  postneonline: (data) => any
  postsconline: (data) => any
  postvtonline: (data) => any
  postwvonline: (data) => any
  postmeonline: (data) => any
  postohonline: (data) => any
  previewReadonlyForms: (formId) => any
  postmionline: (data) => any
  postnmonline: (data) => any
  postnconline: (data) => any
  postnjonline: (data) => any
  postredmondoperations: (data) => any
  postredmondhandbook: (data) => any
  postnyonline: (data) => any
  postrobertsverification: (data) => any
  instates: any
  getinstates: () => void
  getpapsdcodes: (data) => void
  papsdcode: any
  postmnonline: (data) => void
  postHandBookSignOff: (data) => any
  postWakeFieldForm: (data) => any
  getImagePreviewUri: (essFormKey, obkey, stateValue?: string, pageNumber?: number) => any
  postRonsHandBook: (data: any) => any
  PostCityMarketForm: (data: any) => any
  PostDavisForm: (data: any) => any
  postOHAutomation: (data: any) => any
  postFoodCountry: (data: any) => any
  PostGalensForm: (data: any) => any
  getRequestFormsList: (entityId: number, obkey: number | null) => any
  postRequestFormList: (data: any) => any
  postVowellsForm: (data: any) => any
  postSMMarketsOnline: (data: any) => any
}

const useFormsStore = create(
  devtools<Store>((set) => ({
    formList: null,
    loading: false,
    psdloading: false,
    error: null,
    tempdata: null,
    papsdcode: null,
    modetailsData: null,
    progress: 0,
    instates: null,
    clearData: () =>
      set({ formList: null, loading: false, error: null, progress: 0 }),
    fetchData: async (id) => {
      set((state) => ({ ...state, loading: true, error: null }))
      try {
        await delayHttpRequest()
        const _formList = await onboardingService.fetchData(id)
        set((state) => ({ ...state, formList: _formList }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postData: async (id, formId, isdirectdeposit, data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _formList = await onboardingService.postData(
          id,
          formId,
          isdirectdeposit,
          data,
          useFormsStore.getState().updateProgress
        )
        set((state) => ({ ...state, formList: _formList }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false, progress: 0 }))
      }
    },
    markDocAsRead: async (id, formId) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _formList = await onboardingService.markDocAsRead(id, formId)
        set((state) => ({ ...state, formList: _formList }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    previewReadonlyForms: async (formId) => {
      // set((state)=>({...state,loading:true}))
      try {
        await delayHttpRequest()
        return await onboardingService.previewReadonlyForms(formId)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        // set((state)=>({...state,loading:false}))
      }
    },
    updateProgress: async (progress: number) => {
      set((state) => ({ ...state, progress }))
    },
    downloadFile: async (essFormKey: number) => {
      const downloadData = await onboardingService.downloadFile(essFormKey)
    },
    postW4Data: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postW4Data(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getw4Details: async (formkey, obkey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _formList = await onboardingService.getw4Details(formkey, obkey)
        set((state) => ({ ...state, tempdata: _formList }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    submittedForm: async (formkey, obkey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.submittedForm(formkey, obkey)
        //set((state) => ({ ...state, tempdata: _formList }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    posti9details: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.posti9details(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postdirectdepositonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postdirectdepositonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postalonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postalonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postiowaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postiowaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postwotconline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postwotconline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postlaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postlaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postgaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postgaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postcaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postcaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postaronline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postaronline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postkyonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postkyonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postctonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postctonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postazonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postazonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postcoonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postcoonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postdconline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postdconline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postdeonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postdeonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postidonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postidonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    posthionline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.posthionline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postpaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postpaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postMaOnline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postMaOnline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postMdOnline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postMdOnline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postKarnsOnline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postKarnsOnline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postWCRightsOnline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postWCRightsOnline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postEEOOnline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postEEOOnline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postKSonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postKSonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postokonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postokonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postvaonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postvaonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    post8850online: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.post8850online(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postoronline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postoronline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postmoonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmoonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getmodetails: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _modetailsData = await onboardingService.getmodetails(id)
        set((state) => ({ ...state, modetailsData: _modetailsData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postgrenadehandbook: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postgrenadehandbook(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postgrenadepolicy: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postgrenadepolicy(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postmsonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmsonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postilonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postilonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postwionline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postwionline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postinonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postinonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postmtonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmtonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postrionline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postrionline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postneonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postneonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postsconline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postsconline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postvtonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postvtonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postwvonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postwvonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postmeonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmeonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postohonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postohonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postmionline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmionline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postnmonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postnmonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postnconline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postnconline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postnjonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postnjonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postredmondoperations: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postredmondoperations(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postredmondhandbook: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postredmondhandbook(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postnyonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postnyonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postrobertsverification: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postrobertsverification(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getinstates: async () => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _states = await onboardingService.getinstates()
        set((state) => ({ ...state, instates: _states }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getpapsdcodes: async (data) => {
      set((state) => ({ ...state, psdloading: true }))
      try {
        await delayHttpRequest()
        const _codes = await onboardingService.getpapsdcodes(data)
        set((state) => ({ ...state, papsdcode: _codes }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, psdloading: false }))
      }
    },
    postmnonline: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postmnonline(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postHandBookSignOff: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postHandBookSignOff(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    postWakeFieldForm: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postWakeFieldForm(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    getImagePreviewUri: async (essFormKey, obkey, stateValue?: string, pageNumber?: number) => {
      return await onboardingService.getImagePreviewUri(
        essFormKey,
        obkey,
        stateValue,
        pageNumber
      )
    },
    postRonsHandBook: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postRonsHandBook(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    PostCityMarketForm: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.PostCityMarketForm(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    PostDavisForm: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.PostDavisForm(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postOHAutomation: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postOHAutomation(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postFoodCountry: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postFoodCountry(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    PostGalensForm: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.PostGalensForm(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getRequestFormsList: async (entityId: number, obkey: number | null) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.getRequestFormsList(entityId, obkey)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postRequestFormList: async (data: any) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postRequestFormList(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postVowellsForm: async (data: any) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postVowellsForm(data)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postSMMarketsOnline: async (data: any) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await onboardingService.postSMMarketsOnline(data)
      } catch (err: any) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useFormsStore }
